export default function TestAnalysisLoader() {
  return (
    <div className="w-full p-6 pt-4 space-y-6 animate-pulse">
      <div className="flex flex-wrap gap-4 w-full">
        {['Perfect', 'Wasted', 'Overtime', 'Confused'].map((label, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="h-4 w-4 rounded-full bg-[var(--q3-surface-dimmer)]" />
            <div className="h-4 w-24 bg-[var(--q3-surface-dimmer)] rounded" />
          </div>
        ))}
      </div>

      <div className="w-full border rounded-xl overflow-hidden divide-y divide-[var(--q3-stroke-normal)]">
        <div className="grid grid-cols-6 gap-4 px-4 py-3 bg-[var(--q3-surface-dimmer)]">
          {['Subject', 'Perfect', 'Wasted', 'Overtime', 'Confused'].map((header, i) => (
            <div key={i} className="h-4 w-full bg-[var(--q3-surface-dimmest)] rounded" />
          ))}
        </div>
        {[...Array(4)].map((_, idx) => (
          <div key={idx} className="grid grid-cols-6 gap-4 px-4 py-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-4 w-full bg-[var(--q3-surface-dimmer)] rounded" />
            ))}
          </div>
        ))}
      </div>

      <div className="h-6 w-48 bg-[var(--q3-surface-dimmer)] rounded" />
      <div className="flex gap-12 w-full flex-wrap">
        {['Physics', 'Chemistry', 'Mathematics'].map((subject, i) => (
          <div key={i} className="flex flex-col items-center gap-2 flex-1 min-w-[120px]">
            <div className="flex items-end gap-1 h-40 w-full justify-center">
              {[65, 56, 45, 12].map((h, j) => (
                <div
                  key={j}
                  className="w-4 rounded bg-[var(--q3-surface-dimmer)]"
                  style={{ height: `${(h / 75) * 160}px` }}
                />
              ))}
            </div>
            <div className="h-4 w-20 bg-[var(--q3-surface-dimmest)] rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
